export default __webpack_public_path__ + "static/media/190222_K_for_Contact_Intro_30sek.424cf40f.mp4";